import { get } from '@/utils/request'

const state = {
  // 节点树字典
  lineNodeTree: [],
  // 品牌字典
  brandList: [],
  // 部门字典
  departmentList: [],
  // 备件类型字典
  sparePartTypeList: [],
}

const mutations = {
  setLineNodeTree (state, list) {
    state.lineNodeTree = list
  },
  setBrandList (state, list) {
    state.brandList = list
  },
  setDepartmentList (state, list) {
    state.departmentList = list
  },
  setSparePartTypeList (state, list) {
    state.sparePartTypeList = list
  },
}

const actions = {
  /**
   * @descriptio                  发送获取 lineNodeTree 字典数据
   * @param {Object}   context    context对象
   */
  async sendLineNodeTreeReq ({ commit, state }) {
    // 调用获取 lineNodeTree 字典接口
    const res = await get('/api/equipRecord/lineNode/tree')

    const { code } = res

    // 成功则修改 lineNodeTree 字典
    if (code === 'success') {
      const data = res.data.list

      commit('setLineNodeTree', data)

      return state.lineNodeTree
    }
  },
  /**
   * @descriptio                  获取 lineNodeTree 字典数据
   * @param {Object}   context    context对象
   */
  async getLineNodeTree ({ dispatch, state }, isUpload) {
    const { lineNodeTree } = state
    const len = lineNodeTree.length

    // 如果已经获取且不需要强制请求，则从数据中取
    if (len && !isUpload) {
      return lineNodeTree
    }

    // 否则发送请求从后端获取
    const data = await dispatch('sendLineNodeTreeReq')

    return data
  },
  /**
   * @descriptio                  发送获取 brandList 字典数据
   * @param {Object}   context    context对象
   */
  async sendBrandListReq ({ commit, state }) {
    // 调用获取 brandList 字典接口
    const res = await get('/api/equip/list/brand')

    const { code } = res

    // 成功则修改 brandList 字典
    if (code === 'success') {
      const data = res.data.list.map(({ brand, equipRecords }) => ({
        code: brand,
        value: brand,
        equipRecords,
      }))

      commit('setBrandList', data)

      return state.brandList
    }
  },
  /**
   * @descriptio                  获取 brandList 字典数据
   * @param {Object}   context    context对象
   */
  async getBrandList ({ dispatch, state }, isUpload) {
    const { brandList } = state
    const len = brandList.length

    // 如果已经获取且不需要强制请求，则从数据中取
    if (len && !isUpload) {
      return brandList
    }

    // 否则发送请求从后端获取
    const data = await dispatch('sendBrandListReq')

    return data
  },
  /**
   * @descriptio                  发送获取 departmentList 字典数据
   * @param {Object}   context    context对象
   */
  async sendDepartmentListReq ({ commit, state }) {
    // 调用获取 departmentList 字典接口
    const res = await get('/api/dept/getDepts')

    const { code } = res

    // 成功则修改 departmentList 字典
    if (code === 'success') {
      const data = res.data.list.map(({ name, id }) => ({ code: name, value: id }))

      commit('setDepartmentList', data)

      return state.departmentList
    }
  },
  /**
   * @descriptio                  获取 departmentList 字典数据
   * @param {Object}   context    context对象
   */
  async getDepartmentList ({ dispatch, state }, isUpload) {
    const { departmentList } = state
    const len = departmentList.length

    // 如果已经获取且不需要强制请求，则从数据中取
    if (len && !isUpload) {
      return departmentList
    }

    // 否则发送请求从后端获取
    const data = await dispatch('sendDepartmentListReq')

    return data
  },
  /**
   * @descriptio                  发送获取 sparePartTypeList 字典数据
   * @param {Object}   context    context对象
   */
  async sendSparePartTypeListReq ({ commit, state }) {
    // 调用获取 departmentList 字典接口
    const res = await get('/api/equip/repair/type', { type: 'repairType' }, true)

    const { code } = res

    // 成功则修改 departmentList 字典
    if (code === 'success') {
      const data = res.data.list.map(({ code, value }) => ({ code, value }))

      commit('setSparePartTypeList', data)

      return state.sparePartTypeList
    }
  },
  /**
   * @descriptio                  获取 sparePartTypeList 字典数据
   * @param {Object}   context    context对象
   */
  async getSparePartTypeList ({ dispatch, state }, isUpload) {
    const { sparePartTypeList } = state
    const len = sparePartTypeList.length

    // 如果已经获取且不需要强制请求，则从数据中取
    if (len && !isUpload) {
      return sparePartTypeList
    }

    // 否则发送请求从后端获取
    const data = await dispatch('sendSparePartTypeListReq')

    return data
  },
}

export const ManaModeStore = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default ManaModeStore
